import { pathJoin } from 'src/reducers/routing/utils'

export const createTicketsRoutesMap = (prefix: string) => ({
  'ticket-types': pathJoin(prefix)('ticket-types').chain,
  // PRO-400: Services moved here from Customer Management settings. The
  // list-detail routes off `.../tickets/services/:formSelectedId` (LayoutListView).
  services: pathJoin(prefix)('services').chain,
  'ticket-category': pathJoin(prefix)('ticket-category').chain,
  'order-customisation': pathJoin(prefix)('order-customisation').chain,
  'ticket-message-templates': pathJoin(prefix)(
    'ticket-message-templates'
  ).chainMapAuto((prefix2) => ({
    ':id': (id = ':id') => pathJoin(prefix2)(id).chain,
  })),
})
